<template>
  <div class="wrapper-interactivity">
    <div class="header"></div>
    <div :class="customClass">
      <slot></slot>
    </div>
  </div>
</template>

<script >
import { defineComponent } from "vue";
export default defineComponent({
  name: "ModalInteractiveLayout",
  props: {
    customClass: {
      type: String,
      default() {
        return "body";
      },
    },
  },
});
</script>

<style>
.wrapper-interactivity {
  position: absolute;
  left: 0;
  width: 100%;
  background: var(--vm-color-one-08);
  padding: 0px;
  right: 0;
  margin: auto;
  z-index: 1100;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper-interactivity .header {
  display: flex;
}

.wrapper-interactivity .header .btnClose {
  margin-left: auto;
}

.wrapper-interactivity:target {
  display: flex;
}

.wrapper-interactivity .body {
  width: 33%;
  border-radius: 0.8rem;
  color: var(--vm-color-three);;
  background: linear-gradient(to right bottom, var(--vm-color-one-04), var(--vm-color-one) 74%);
  box-shadow: 0rem 0rem 1rem 0.1rem var(--vm-color-one-06);
  height: auto;
  padding: 1em;
  position: relative;
  font-family: "Open Sans", sans-serif;
}

.inter-modal-header {
  text-align: center;
  border-bottom: 1px solid var(--vm-color-three-04);
}

.inter-modal-title {
  font-size: 1.75rem;
  text-transform: uppercase;
}

.inter-modal-desc {
  font-size: 1.25rem;
  font-style: italic;
}

.inter-modal-content {
  font-size: 1rem;
  line-height: 2;
  padding: 0.75em 1em;
}

.inter-modal-content::before {
  content: "";
  position: absolute;
  top: 0%;
  left: 100%;
  transform: translate(-50%, -50%);
  border: 1px solid var(--vm-color-three-02);
  border-radius: 100rem;
  pointer-events: none;
}

.inter-modal-choice {
  border: 1px solid #b1b1b1;
  border-radius: 10px;
  padding: 0 0.5em;
  cursor: pointer;
  margin-bottom: 0.75em;
}

.inter-modal-choice.selected {
  border-radius: 10px;
  padding: 0 0.5em;
  cursor: pointer;
  margin-bottom: 0.75em;
  background: var(--vm-color-three-08);
  color: var(--vm-color-one-08);}

.inter-modal-footer {
  float: right;
}

.inter-modal-btn {
  border: 1px solid var(--vm-color-three-04) !important;
  border-radius: 100rem;
  color: inherit;
  background: transparent;
  font-family: inherit;
  letter-spacing: 0.2rem;
  transition: 0.2s !important;
  cursor: pointer;
  padding: 0.5em;
  margin: 0.5em;
}

.inter-modal-btn:hover,
.inter-modal-btn:focus {
  border-color: var(--vm-color-three-04);;
  transform: translateY(-0.2rem);
}

@media screen and (max-width: 992px) {
  .wrapper-interactivity {
    position: fixed;
    z-index: 51;
  }

  .wrapper-interactivity .body {
    width: 60%;
    padding: 0.75em;
  }

  .inter-modal-btn {
    font-size: 0.6em !important;
  }
}

@media screen and (max-width: 450px) {
  .wrapper-interactivity .body {
    width: 80%;
  }

  .inter-modal-btn {
    font-size: 2vw !important;
  }

  .inter-modal-title {
    font-size: 3vw;
    margin: 0.25em;
  }

  .inter-modal-desc {
    font-size: 2.75vw;
    margin: 0.25em;
  }

  .inter-modal-content {
    font-size: 2.5vw;
    line-height: 1.3;
    padding: 0.5em 0.75em;
  }
}

@media screen and (max-height: 500px) {
  .inter-modal-btn {
    font-size: 2vw !important;
  }

  .inter-modal-title {
    font-size: 3vw;
    margin: 0.25em;
  }

  .inter-modal-desc {
    font-size: 2.75vw;
    margin: 0.25em;
  }

  .inter-modal-content {
    font-size: 2.5vw;
    line-height: 1.3;
    padding: 0.5em 0.75em;
  }
}</style>
